import React, { useState, useEffect } from "react";
import Axios from './../../../../utils/api/axiosConf';
import { url } from './../../../../utils/api/api';
import { RedNotif, GreenNotif } from "../../../../utils/utils";
import LOADING from "../../../../components/loading/loading";
import UPLOAD from "../../../../components/uoload/upload";
import { Col, Row } from "antd";
import { Uploder } from "../../../../utils/utils";
import BUTTON from "./../../../../components/buttons/button"
import TEXTROW from "../../../../components/textRow";

export default function Evidence(props) {

    const userId = props.userId
    const [image, setImage] = useState({ "id": null, "link": null })
    const [loading, setLoading] = useState({ 1: false, 2: false, 3: false });
    const [resume, setResume] = useState()

    useEffect(() => {
        setLoading({ ...loading, 1: true })
        Axios.get(`${url}users/cv-coch/${userId}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    console.log(response)
                    setResume(response.data.cv)
                    if (response.data.coachingCard != undefined) {
                        setImage({ "id": response.data.coachingCard._id, "link": `${url}${response.data.coachingCard.path}` })
                    }
                    setLoading({ ...loading, 1: false })
                }
                else {
                    RedNotif(response.message)
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });
    }, [])

    const upload = async (e) => {
        var res = await Uploder(e, "profile")
        if (res.status == 200 || res.status == 201) {
            setLoading({ ...loading, 2: false })
            setImage({ "id": res.data._id, "link": `${url}${res.data.path}` })
        }
    }

    const updateCoachProfile = () => {
        setLoading({ ...loading, 3: true })
        var data = {
            "cv": resume,
            "coachingCard": image.id
        }

        Axios.patch(`${url}users/edit-cv-coch/${userId}`, data)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setLoading({ ...loading, 3: false })
                    GreenNotif(response.message)
                    props.pager(2)
                }
                else {
                    RedNotif(response.message)
                    setLoading({ ...loading, 3: false })
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
                setLoading({ ...loading, 3: false })

            });
    }

    switch (loading[1]) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>
                <Row >
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                        <p style={{ margin: "15px !important" }}>کارت مربیگیری:</p>
                        <div style={{ width: "250px", height: '150px', margin: "10px 0" }}>
                            <UPLOAD
                                accept={".png,.jpeg,.jpg"}
                                click={(e) => {
                                    setLoading({ ...loading, 2: true })
                                    upload(e)
                                }} loading={loading[2]}
                                defultImage={image.link}
                            />
                        </div>
                        <p>رزومه مربی:</p>
                        <TEXTROW i={(e) => { setResume(e) }} value={resume} />
                    </Col>

                </Row>
                <Row style={{ marginTop: '64px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON
                            text={"بروزرسانی مدرک مربی"}
                            loading={loading[3]}
                            event={(e) => updateCoachProfile()}
                            type={"submit"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => props.pager(2)} text="رد کردن" type={"cancel"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>
            </>
        )
    }
}
